import { useSortableTable } from '~/hooks/useSortableTable';
import { Table } from '~/components/Table/Table';
import { Link } from '~/components/Link/Link';
import { District } from '~/apis/ssf';

interface Props {
  districts: District[];
  isLoading: boolean;
}

export function DistrictListTable({ districts, isLoading }: Props) {
  const { register } = useSortableTable('name');

  return (
    <Table bg="even">
      <Table.Head>
        <Table.Row>
          <Table.Col {...register('name')} as="th">
            Distrikt
          </Table.Col>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {isLoading ? (
          <Table.Loading cols={1} />
        ) : (
          districts.map(district => (
            <Table.Row key={`district-${district.id}`}>
              <Table.Col>
                <Link to={`${district.id}`}>{district.name}</Link>
              </Table.Col>
            </Table.Row>
          ))
        )}
      </Table.Body>
    </Table>
  );
}
